module.exports = __webpack_public_path__ + "static/media/product.ba02a79b.webp";